import { SignupScreen, UserProfile } from 'fitbeat.gym-core';
import { Allergens } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { Text, View } from 'react-native';
import { connect } from 'react-redux';
import { Button } from '../components';
import { AllergenPreference } from '../settings/components/AllergenPreference';
import Theme from '../theme';
import theme from '../theme';
import { defaultScale } from '../utils/scaling';
import { getNextStep, navigateToNextStep } from './actions';
import { sharedStyles } from './OnboardingSharedStyles';
import { INavigateToNextStep } from './types';

interface IProps {
  userProfile: UserProfile;
  navigation: any;

  t(key: string): string;

  getNextStep(navigateToNextStep: INavigateToNextStep): void;

  navigateToNextStep(navigateToNextStep: any): void;
}

interface IState {
  allergens: Allergens[];
}

class HomeAllergenScreenComponent extends PureComponent<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      allergens: [],
    };
  }
  public render() {
    const { t } = this.props;
    return (
      <View style={[sharedStyles.container, { justifyContent: 'space-between' }]}>
        <View>
          <Text
            style={[Theme.textStyle.heading, { marginBottom: defaultScale(6) }]}
          >
            {t('WhatAllergiesDoYouHave')}
          </Text>
          <Text
            style={[
              Theme.textStyle.bodyCopyReg,
              { color: Theme.GREY_MEDIUM, marginBottom: defaultScale(24) },
            ]}
          >
            {t('personalizeAllergies')}
          </Text>
          <AllergenPreference
            onSelected={this.onAllergenSelected}
            onUnselected={this.onAllergenUnSelected}
            selectedAllergens={this.state.allergens}
            textStyle={theme.textStyle.bodyCopyBold}
          />
        </View>
        <Button
          title={t('next')}
          fontColor={theme.WHITE}
          onPress={this.setAllergensAndNavigateToNextStep}
          containerStyle={{
            marginTop: defaultScale(15),
            marginBottom: defaultScale(30),
            height: defaultScale(45),
          }}
        />
      </View>
    );
  }

  private onAllergenSelected = (allergen) => {
    const newAllergenSelection = [...this.state.allergens, allergen];
    this.updateAllergens(newAllergenSelection);
  }

  private onAllergenUnSelected = (allergen) => {
    const newAllergenSelection = this.state.allergens.filter(
      (item) => item !== allergen,
    );
    this.updateAllergens(newAllergenSelection);
  }

  private updateAllergens = (newAllergenSelection) => {
    this.setState({
      allergens: newAllergenSelection,
    });
  }

  private setAllergensAndNavigateToNextStep = () => {
    const { allergens } = this.state;
    this.props.getNextStep({
      currentScreen: SignupScreen.Allergens,
      userProfile: { allergens },
    });
    this.props.navigateToNextStep(this.props.navigation);
  }
}

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
};

export const HomeAllergenScreen = translate(['auth'], { wait: true })(
  connect(null, mapDispatchToProps)(HomeAllergenScreenComponent),
);
